module.exports = __webpack_public_path__ + "img/wiping_swipe_for_floors.7f346f7e.svg";